import { getEmptyRow } from "@src/routes/projects/$projectId/selections/batch/$category/store/helpers/getEmptyRow";
import { BatchSelectionRow } from "@src/routes/projects/$projectId/selections/batch/$category/store/types";

type BatchSelectionInputColumn = Exclude<
  keyof BatchSelectionRow,
  "inputErrors" | "output" | "status"
>;

const batchSelectionColumns = Object.keys(
  getEmptyRow(),
) as BatchSelectionInputColumn[];

export function isBatchSelectionInputColumn(
  columnId?: unknown,
): columnId is BatchSelectionInputColumn {
  if (!columnId) return false;
  return batchSelectionColumns.includes(columnId as BatchSelectionInputColumn);
}
